import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Avatar from "react-avatar";
import Logo from "../../Assets/logo.png";
import { Link } from "react-router-dom";

const Navbar = () => {
  const dispatch = useDispatch();
  const { firstname, lastname } = useSelector((state) => state?.auth?.student?.student);

  const logoutHandler = () => {
    dispatch({ type: "LOGOUT_STUDENT" });
    toast.success("Logged Out Successfully!");
  };

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(err => {
        console.error(`Error attempting to enable fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <nav className="sticky top-0 bg-white border-b border-gray-200 shadow-sm">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Left Section - Logo */}
          <div className="hidden sm:block sm:ml-6">
            <Link to='/'>
            <img src={Logo} alt="Logo" className="h-10 w-auto" />
            </Link>
          </div>

          {/* Right Section - Actions */}
          <div className="flex items-center space-x-4">
            <button
              onClick={toggleFullScreen}
              className="p-2 text-gray-500 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              aria-label="Toggle fullscreen"
            >
              <FullscreenExitOutlinedIcon className="w-5 h-5" />
            </button>

            <button className="p-2 text-gray-500 rounded-full hover:bg-gray-100">
              <NotificationsNoneIcon className="w-5 h-5" />
              <span className="sr-only">Notifications</span>
            </button>

            <div className="flex items-center">
              <Avatar 
                name={`${firstname} ${lastname}`} 
                size="36"
                round
                className="border-2 border-white shadow-md"
                color="#3B82F6"
              />
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-700">
                  {firstname} {lastname}
                </p>
                <p className="text-xs font-medium text-gray-500">
                  Student Account
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
